import { Button, Flex, Layout, Menu, Typography } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { useSession } from './session-context';
import { Link, Outlet, useLocation } from 'react-router';
import { ROUTES } from './routes';
import { ApiStatus } from './ApiStatus';

const { Header, Sider, Content } = Layout;

export function AppLayout() {
  const { pathname } = useLocation();
  const { user, session } = useSession();
  const selected = ROUTES.find((r) => r.path !== '/' && pathname.startsWith(r.path))?.path ?? '/';

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider breakpoint="lg" collapsedWidth={0} theme="light" width={220}>
        <Typography.Title level={5} style={{ padding: '16px 24px', margin: 0 }}>
          아이소리 어드민
        </Typography.Title>
        <Menu
          mode="inline"
          selectedKeys={[selected]}
          // 링크로 렌더링해 새 탭 열기·주소 복사가 가능하게 한다.
          items={ROUTES.map((r) => ({ key: r.path, icon: r.icon, label: <Link to={r.path}>{r.label}</Link> }))}
        />
      </Sider>
      <Layout>
        {/* 휴대폰(실기기 점검 #111)에서도 쓰므로 좁은 화면에서는 여백을 줄인다 */}
        <Header style={{ background: 'transparent', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingInline: 'clamp(12px, 4vw, 24px)', height: 'auto', minHeight: 64, lineHeight: 'normal' }}>
          <Flex align="center" gap={12} wrap justify="flex-end" style={{ padding: '8px 0' }}>
            <ApiStatus />
            {user?.email && <Typography.Text type="secondary">{user.email}</Typography.Text>}
            <Button size="small" icon={<LogoutOutlined />} onClick={() => session.signOut()}>
              로그아웃
            </Button>
          </Flex>
        </Header>
        <Content style={{ padding: 'clamp(12px, 4vw, 24px)' }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
